var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-card",class:{ 'r-card--round': _vm.round },on:{"click":_vm.clickHandler,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.clickHandler.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }